import { render, staticRenderFns } from "./TabSig.vue?vue&type=template&id=5baafc43&"
import script from "./TabSig.vue?vue&type=script&lang=js&"
export * from "./TabSig.vue?vue&type=script&lang=js&"
import style0 from "./TabSig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports